import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DropdownButton } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import * as fromAccessActions from 'store/actions/access.action'
import { IMainState } from 'store/states'
import { ICoursePermissions } from 'store/states/access.state'
import * as fromActions from 'store/actions/courses.action'
import { CourseType } from 'enum/course-type.enum'
import { DropdownLoader } from 'components/ui/DropdownLoader'
import { useAccess } from 'contexts/AccessContext'
import { createRouteMonitoringCourse } from 'enum/routes'
import styles from './Options.module.scss'

interface IProps {
  id: any
  name: any
  onDeleteClick: any
  onDuplicateClick: any
  courseType: CourseType
  integrationCourseLink: string
  synchronous: boolean
}

const initialState = {
  canAnswer: false,
  canDownload: false,
  canEdit: false,
  canMonitor: false,
  loading: false,
  id: 0,
  canManageCourses: false,
} as ICoursePermissions

const Options: React.FC<IProps> = ({
  id,
  name,
  onDeleteClick,
  onDuplicateClick,
  integrationCourseLink,
  synchronous,
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const { permission } = useSelector(({ user }: IMainState) => user)
  const access = useSelector(({ access }: IMainState) => access.courses[id])
  const [
    { loading, canDownload, canEdit, canMonitor, canManageCourses },
    setCoursePermissions,
  ] = useState(initialState)

  const {
    permissions: { all },
  } = useAccess()
  const [show, setShow] = useState(false)
  const [auxShow, setAuxShow] = useState(false)

  useEffect(() => {
    if (auxShow && access?.id) {
      setCoursePermissions(access)
      setShow(true)
      setAuxShow(false)
    }
  }, [access, auxShow])

  useEffect(() => {
    if (auxShow) {
      dispatch({ type: fromAccessActions.CAN_COURSE, payload: id })
    }
  }, [auxShow, dispatch, id])

  const handleDropdownClick = (show: boolean) => {
    if (show && permission.moderator) {
      setAuxShow(true)
    } else {
      setShow(show)
    }
  }

  const handleDownload = (id: number) => {
    setShow(false)
    setAuxShow(false)
    dispatch(fromActions.Actions.coursesIndividualDownload({ courseId: id }))
  }

  return (
    <DropdownButton
      show={show}
      id="dropdown-menu-align-right"
      className={styles.actionSelect}
      alignRight
      title={<DropdownLoader loading={loading} />}
      onClick={() => handleDropdownClick(!show)}
      onToggle={() => handleDropdownClick(!show)}
    >
      {show && (
        <>
          {(all || (permission.moderator && canMonitor)) && (
            <a
              onClick={() => {
                const url = createRouteMonitoringCourse({
                  id,
                })
                history.push(url)
              }}
            >
              {t(
                'administration.courses.list.create.table.headers.actions.seeMonitoring'
              )}
            </a>
          )}
          {(all ||
            canManageCourses ||
            (permission.moderator &&
              (canMonitor || canEdit || canDownload))) && (
            <a
              href={`/administration/courses/${id}/preview`}
              target="_blank"
              className={
                integrationCourseLink || synchronous
                  ? styles.optionDisabled
                  : ''
              }
            >
              {t('administration.lessons.buttons.preview')}
            </a>
          )}
          {(all || canManageCourses || (permission.moderator && canEdit)) && (
            <a
              onClick={() => history.push(`/administration/courses/${id}/edit`)}
            >
              {t(
                'administration.courses.list.create.table.headers.actions.edit'
              )}
            </a>
          )}
          {(all || canManageCourses) && (
            <a onClick={() => onDeleteClick(id || 0, name)}>
              {t(
                'administration.courses.list.create.table.headers.actions.delete'
              )}
            </a>
          )}
          {(all || canManageCourses) && (
            <a
              onClick={() => onDuplicateClick(id || 0)}
              className={integrationCourseLink ? styles.optionDisabled : ''}
            >
              {t(
                'administration.courses.list.create.table.headers.actions.duplicate'
              )}
            </a>
          )}
          {!integrationCourseLink &&
            (all || (permission.moderator && canDownload)) && (
              <a onClick={() => handleDownload(id)}>
                {t(
                  'administration.courses.list.create.table.headers.actions.report'
                )}
              </a>
            )}
        </>
      )}
    </DropdownButton>
  )
}

export default Options
